import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import Header from "../header/header";

export default function Notauthorized() {
  return (
    <>
      <Header />
      <Container className="mt-5">
        <Row>
          <Col xl={12} className="mb-5">
            <Card className="shadow card_border not-auth-pg p-4 text-center">
              <Card.Body>
                <h4 className="mb-0">Not Authorized</h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
